import React from 'react';
import { 
  Box,
  Tooltip
} from '@mui/material';
import { Switch, FormControlLabel} from '@mui/material';
import { Home } from '@mui/icons-material';
//utils
import styles from '../../styles/component.module.scss';
import stylesProjectPage from '../../styles/projectPage/index.module.scss';
//components
import PageHeader from '../Header/PageHeader';
import TabView from '../tabView/TabView';
import ProjectGridTab from "./ProjectGridTab";
import ProjectListTab from "./ProjectListTab";
import { updatePageList } from '../../features/userPreference/userPreferenceSlice';
import { useDispatch, useSelector } from 'react-redux';
import { updateUserPreferences } from '../../utils/api/userPreference_apis';
import { STATUS } from '../../utils/api/sharedfunction';
import { ScaleEnum } from '../../enums/enumRegistry';

const Projects = () => {
  const projectPageView = useSelector(state => state.userPreference.ProjectPageView);
  const ProjectListPage = useSelector((state) => state.userPreference?.ProjectListPageConfigure || {})
  const dispatch = useDispatch();

  const handleToggle = async (event) => {
    const value = event.target.checked ? 'list' : 'grid';
    dispatch(updatePageList(value));
    let selectedColumns = [];
    for(let key in ProjectListPage?.columnVisible || {}){
      if(ProjectListPage?.columnVisible[key]){
        selectedColumns.push(key);
      }
    }
    const payload = [{
      viewType: 'projectList',
          preferences: { ...ProjectListPage, projectPageView: value, columnVisible: selectedColumns}
      }]
    const response = await updateUserPreferences(payload);
    
    if (response.status === STATUS.ERROR) {
      console.error('Failed to update user preferences:', response.error);
    }
  };


  const tabsData = [
    {
      name: 'Grid View',
      component: <ProjectGridTab />
    },
    {
      name: 'List View',
      component: <ProjectListTab />
    }
  ];

  const pageHeaderData = [
    { label: 'Projects' }
  ];

  return (
    <Box className={styles['page-container']}>
      <Box>
        <PageHeader
          projectName={null}
          title="Projects"
          description="View, create, and manage your projects."
          activePage="Projects"
          breadcrumbItems={pageHeaderData}
          actions={[]}
        />
      </Box>
      <Box className={styles['cover-container-col']}>
        <Box className={stylesProjectPage['tab-container']}>
          <FormControlLabel
            control={<Switch checked={projectPageView==='list'} onChange={handleToggle} />}
            label={projectPageView==='list' ? 'List View' : 'Grid View'}
          />
        </Box>
        <Box className={styles['cover-container-col']} sx={{ width: '100%', paddingX: 2, paddingTop: 0 }}>
          {projectPageView==='list' ? <ProjectListTab /> : <ProjectGridTab />}
        </Box>
      </Box>
    </Box>
  );
};

export default Projects;
